import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Welcome from 'containers/welcome/Welcome';
import Motivator from 'containers/motivator/Motivator';
import PreEngagement from 'containers/motivator/PreEngagement';
import GoToMyReport from 'containers/engagement/GoToMyReport';
import PreliminaryQuestions from 'containers/PreliminaryQuestions';
import Engagement from 'containers/engagement/Engagement';
import ExpireEngagement from 'containers/engagement/Expire';
import ThankYou from 'containers/engagement/ThankYou';

import {
    ENGAGEMENT,
    EXPIRED_ENGAGEMENT,
    GO_TO_MY_REPORT,
    MOTIVATOR,
    PRE_ENGAGEMENT,
    PRELIMINARY_QUESTIONS,
    THANK_YOU,
    WELCOME
} from 'constants/pageDictionary';

import './MainLayout.scss';

const pageDictionary = {
    [WELCOME]: (<Welcome />),
    [ENGAGEMENT]: (<Engagement />),
    [MOTIVATOR]: (<Motivator />),
    [PRE_ENGAGEMENT]: (<PreEngagement />),
    [GO_TO_MY_REPORT]: (<GoToMyReport />),
    [PRELIMINARY_QUESTIONS]: (<PreliminaryQuestions />),
    [EXPIRED_ENGAGEMENT]: (<ExpireEngagement />),
    [THANK_YOU]: (<ThankYou />)
};

const getBackgroundColor = (page) => {
    switch (page) {
    case WELCOME:
        return '#1E3C4D';
    case ENGAGEMENT:
        return '#1E3C4D';
    case MOTIVATOR:
        return 'white';
    case PRE_ENGAGEMENT:
        return '#1E3C4D';
    case GO_TO_MY_REPORT:
        return '#1E3C4D';
    case PRELIMINARY_QUESTIONS:
        return 'white';
    case EXPIRED_ENGAGEMENT:
        return '#1E3C4D';
    case THANK_YOU:
        return 'white';
    default:
        return 'white';
    }
};

class MainLayout extends Component {
    render() {
        const { pageReducer } = this.props;
        const page = pageReducer.get('goToPage') || WELCOME;

        if (page === ENGAGEMENT || page === EXPIRED_ENGAGEMENT) {
            return pageDictionary[page];
        }

        return (
            <div className='fl-survey-main-layout' style={ { background: getBackgroundColor(page) } }>
                { pageDictionary[page] }
            </div>
        );
    }
}

MainLayout.propTypes = {
    pageReducer: PropTypes.object
};

MainLayout.defaultProps = {
    pageReducer: null
};

const mapStateToProps = (state) => ({
    pageReducer: state.pageReducer
});

export default connect(mapStateToProps, null)(MainLayout);
